export const FETCH_ADMIN_SUMMARY_REQUEST = "FETCH_ADMIN_SUMMARY_REQUEST";
export const FETCH_ADMIN_SUMMARY_SUCCESS = "FETCH_ADMIN_SUMMARY_SUCCESS";
export const FETCH_ADMIN_SUMMARY_FAILURE = "FETCH_ADMIN_SUMMARY_FAILURE";
